import {
  SendSignUpModal,
  sendSignUpModal,
  SendSignUpSuccessModal,
  sendSignUpSuccessModal,
} from '../../../design-system';
import { AuthFooterLanguage, AuthWrapper } from '../AuthComponents';
import { SignInHeader, SignInForm, SignInFooter } from './SignInComponents';
import { useIsSmallScreen } from '../../../hooks';

export const SignIn = () => {
  const isSmallScreen = useIsSmallScreen();

  const handleSendSignUpClick = () => {
    sendSignUpModal.price = null;
    sendSignUpModal.number = null;
    sendSignUpModal.withCategory = true;
    sendSignUpModal.submitClick = () => {
      sendSignUpSuccessModal.open();
    };
    sendSignUpModal.open();
  };

  return (
    <>
      <AuthWrapper>
        <SignInHeader />
        <SignInForm />
        <SignInFooter handleSendSignUpClick={handleSendSignUpClick} />
        {!isSmallScreen && <AuthFooterLanguage />}
      </AuthWrapper>
      <SendSignUpModal />
      <SendSignUpSuccessModal />
    </>
  );
};
